import React from 'react'
import ReactDOM from 'react-dom'
import './styles/reset.css'
import './styles/index.css'
import App from './App/'
import { BrowserRouter as Router } from 'react-router-dom'
import ScrollToTop from 'react-router-scroll-top'
import objectFitImages from 'object-fit-images'
import * as Sentry from '@sentry/browser';
import * as serviceWorker from './registerServiceWorker'

import { AUTH_TOKEN } from './constants'

import { ApolloProvider } from 'react-apollo'
import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context' 

Sentry.init({ dsn: 'https://b0210c072f5c48669877fd8927577fd3@sentry.io/1480155' });

const httpLink = createHttpLink({
  uri:
    process.env.REACT_APP_HOST_ENV === 'production'
      ? 'https://api.kaarskoffie.nl/'
      : process.env.REACT_APP_HOST_ENV === 'staging'
        ? 'https://kaarskoffieapi.bureaubright.nl'
        : 'https://kaarskoffieapi.bureaubright.nl'
})

console.log('ENV: ', process.env.REACT_APP_HOST_ENV)

const authLink = setContext((_, { headers }) => {
  const token = window.localStorage.getItem(AUTH_TOKEN)
    ? window.localStorage.getItem(AUTH_TOKEN)
    : window.sessionStorage.getItem(AUTH_TOKEN)
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
})

objectFitImages()

ReactDOM.render(
  <Router onUpdate={() => window.scrollTo(0, 0)}>
    <ApolloProvider client={client}>
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </ApolloProvider>
  </Router>,
  document.getElementById('root')
)

serviceWorker.unregister()



// WEBPACK FOOTER //
// ./src/index.js